import { ThemeProvider } from '@mui/system';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Router from './Router';
import { defaultTheme } from './Themes';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.Fragment>
    <ThemeProvider theme={defaultTheme}>
      <Router />
    </ThemeProvider>
  </React.Fragment>
);
